
import './Rank.css';
import { useRef } from 'react';
import * as THREE from 'three';
import { render } from '@testing-library/react';
import {extend,useFrame, Canvas, useThree, useLoader} from "@react-three/fiber";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import {Environment,OrbitControls, PerspectiveCamera } from '@react-three/drei';
import { BufferGeometry } from 'three';
import {Suspense} from 'react';
const RankList=[];
for (let i=0; i<10;i++){
  RankList.push(<div  id={"player"+`${i}`} className={'listComponent'}>{i+1}</div>)
}
const Model = () => {
  const gltf = useLoader(GLTFLoader, "../birth_of_venus_in_neon/scene.gltf");
  
  return (
    <>
      <primitive position={[-0.1,-0.1,1.2]}  object={gltf.scene} scale={0.1} />
    </>
  );
};
const Camera=()=>{
  const ref=useRef();
  useFrame(state=>{
     ref.current.rotation.y+=0.002;
    //  ref.current.rotation.y+=0.01;
    
   }
     )
  return(
    <>
      <PerspectiveCamera ref={ref} makeDefault position={[0,0.12,0]}/>
    </>
  )
}
function Rank(){

    return (
        <div id='Rank'>
                <div className='leftSideContainer'>
                  <div>
                    <div className='RankList'>
                          <div className='RankListContainer'>
                            {RankList}
                          </div>
                    </div>
                    <h1 style={{margin:'20px'}}>Seasons 2022</h1>
                  </div>
                </div>
                <div className='YearlyModel'>
                  <Canvas>
                    <Suspense fallback={null}>
                      <Camera/>
                      <ambientLight/>
                      <Model />
                    </Suspense>
                  </Canvas>
                </div>
        </div>
      );
}
  


export default Rank;